import React, { useEffect, useState } from "react";
import { Page, SubmitButton, FormGroup } from "components/common";
import { Control, actions } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import { Trans } from "react-i18next";
import { Button } from "reactstrap";
import BackButton from "components/refactoring/BackButton";
import { useXeroClient } from "hooks";


export const CustomOrganisationSettings = ({ t, url = "all/custom_org_settings", model = "local", history, match, }) => { 
  const [reload, setReload] = useState(false);
  const xero = useXeroClient();
  

  const { dispatch, setValue, Form, save, loaded, load, getTitle, value } =
    useForm({
      model,
    });


    useEffect(() => {

      async function fetchData() {
        
        const item = await xero.get(url).get("data")
          
        setValue(item);
  
      }
      fetchData();
    }, [reload, ]);

    async function onSubmit(item) {
      try {
        const resp = await xero.post(url, item);
        NotificationManager.success(t("Saved successfully"));
        setReload(!reload)
      } finally {
        dispatch(actions.setPending(model, false));
      }
    }

    async function Reset() {
      try {
        const resp = await xero.delete(url);
        NotificationManager.success(t("Deleted successfully"));
        setReload(!reload)
      } finally {
        dispatch(actions.setPending(model, false));
      }
    }
  
    
  return (
    <Page title="Invoice Settings">
      <BackButton/>
      <Form
        onSubmit={onSubmit}
        validators={{
          // employee: { required },
          }}
      >
        <FormGroup model=".name" label="Name" className="py-2">
          <Control.text rows="4" model=".name" style={{backgroundColor:'#F4F7FE'}}/>
        </FormGroup>
        <FormGroup model=".vat_number" label="VAT Number">
          <Control.text model=".vat_number" style={{backgroundColor:'#F4F7FE'}}/>
        </FormGroup>
        <FormGroup model=".registration_number" label="Registration Number">
          <Control.text model=".registration_number" type="Number" style={{backgroundColor:'#F4F7FE'}}/>
        </FormGroup>
        <FormGroup model=".address" label="Address">
          <Control.textarea rows="4" model=".address" style={{backgroundColor:'#F4F7FE'}}/>
        </FormGroup>
        <FormGroup model=".city" label="City">
          <Control.text rows="4" model=".city" style={{backgroundColor:'#F4F7FE'}}/>
        </FormGroup>
        <FormGroup model=".country" label="Country">
          <Control.text rows="4" model=".country" style={{backgroundColor:'#F4F7FE'}}/>
        </FormGroup>
        <FormGroup model=".region" label="Region">
          <Control.text rows="4" model=".region" style={{backgroundColor:'#F4F7FE'}}/>
        </FormGroup>
        <FormGroup model=".postal_code" label="Postal Code">
          <Control.text rows="4" model=".postal_code" style={{backgroundColor:'#F4F7FE'}} type="number"/>
        </FormGroup>
        <FormGroup model=".building_number" label="Building Number">
          <Control.text rows="4" model=".building_number" style={{backgroundColor:'#F4F7FE'}} type="number"/>
        </FormGroup>
        <FormGroup model=".plot_number" label="Plot Number">
          <Control.text rows="4" model=".plot_number" style={{backgroundColor:'#F4F7FE'}} type="number"/>
        </FormGroup>
        <div className="my-3">
          <SubmitButton>Save</SubmitButton>
          <Button className="ml-1 mr-0 btn btn-danger" onClick={() => { Reset() }}><Trans>Reset to Xero Settings</Trans></Button>
        </div>
      </Form>
    </Page>
  )
}


export default CustomOrganisationSettings;
